import { Tabs } from 'flowbite';

export default class InitTabs {
    constructor({containerId, contentContainerSelector = null, defaultTabId = null,
                    activeClasses = 'tab-active', inactiveClasses = 'tab-inactive'
    }) {
        this.container = document.getElementById(containerId);
        if (!this.container) {
            console.warn(`No se encontró el contenedor con ID: ${containerId}`);
            return;
        }

        this.contentContainer = contentContainerSelector
            ? document.querySelector(contentContainerSelector)
            : this._autodetectContentContainer();

        if (!this.contentContainer) {
            console.warn('No se pudo encontrar automáticamente el contenedor de contenido.');
            return;
        }

        this.activeClasses = activeClasses;
        this.inactiveClasses = inactiveClasses;

        this.tabElements = this._buildTabElements();
        const firstTabId = this.tabElements.length > 0 ? this.tabElements[0].id : null;

        this.options = {
            defaultTabId: defaultTabId || firstTabId,
            activeClasses: this.activeClasses,
            inactiveClasses: this.inactiveClasses,
            onShow: (tab) => {
                // Opcional: callback al mostrar tab
            },
        };

        this.instanceOptions = { id: containerId, override: true };
        this.tabs = new Tabs(this.container, this.tabElements, this.options, this.instanceOptions);

        if (this.options.defaultTabId) {
            this.show(this.options.defaultTabId);
        }

        this._addTransitions();

    }

    _autodetectContentContainer() {
        // Buscar elementos con id que comience con 'content-'
        const allPanels = document.querySelectorAll('[id^="content-"]');

        for (const panel of allPanels) {
            if (this.container.contains(panel)) {
                return panel.parentElement;
            }
        }

        // Fallback: buscar cualquier contenedor que tenga hijos con id="content-*"
        const candidates = Array.from(document.querySelectorAll('*')).filter(el => {
            const children = Array.from(el.children);
            return children.some(child => child.id?.startsWith('content-'));
        });

        if (candidates.length > 0) {
            return candidates[0];
        }

        return null;
    }

    _buildTabElements() {
        const triggers = this.container.querySelectorAll('[id^="tab-"]');

        return Array.from(triggers).map(trigger => {
            const contentId = trigger.id.replace('tab-', 'content-');
            const target = this.contentContainer.querySelector(`#${contentId}`);
            if (!target) {
                console.warn(`No se encontró el contenido con ID: ${contentId} para el tab ${trigger.id}`);
            }
            return { id: contentId, triggerEl: trigger, targetEl: target };
        }).filter(tab => tab.targetEl);
    }

    _addTransitions() {
        const panels = this.contentContainer.querySelectorAll('[id^="content-"]');
        panels.forEach(panel => {
            panel.style.transition = 'opacity 0.3s ease-in-out';

            // Excluir elementos específicos
            const excludedElements = panel.querySelectorAll('.icon-expand, .card-image img');
            excludedElements.forEach(el => {
                el.style.transition = 'none';
            });
        });
    }


    show(id) {
        this.tabs?.show(id);
    }

    getTab(id) {
        return this.tabs?.getTab(id);
    }

    getActiveTab() {
        return this.tabs?.getActiveTab();
    }
}
